import { type AppSettings } from './app-settings.model';
import { parseAppSettings } from './settings.validation';

let inFlight: Promise<AppSettings> | null = null;

/**
 * Fetches the runtime config served at /config.json. Memoized so concurrent
 * callers share one request. Resolved before bootstrapApplication, because
 * Sentry init and provideNgxStripe both need values before the injector exists.
 */
export function loadAppSettings(): Promise<AppSettings> {
  return (inFlight ??= fetchAppSettings());
}

async function fetchAppSettings(): Promise<AppSettings> {
  const response = await fetch('/config.json');

  if (!response.ok) {
    throw new Error(`Failed to load /config.json: ${response.status} ${response.statusText}`);
  }

  let payload: unknown;

  try {
    payload = await response.json();
  } catch {
    throw new Error('Failed to load /config.json: response is not valid JSON.');
  }

  return parseAppSettings(payload);
}
